import { Injectable } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { SectionType } from 'enums-lib';
import { ISharedTemplateFeatures } from '../workflow-config.component';

@Injectable({ providedIn: 'root' })
export class DocMergeWorkflowConfigService implements ISharedTemplateFeatures {
  private static docMergeSectionTypes: SectionType[] = [
    SectionType.DocxTemplate,
    SectionType.HtmlDocxTemplate,
    SectionType.File,
    SectionType.FixedFile,
    SectionType.DocMergeTemplateSection,
    SectionType.Certification,
  ];

  get sectionValidators(): ValidatorFn {
    return (form: FormControl): ValidationErrors | null => {
      return this.hasDynamicSections(form) ? null : { missingDynamicSection: true };
    };
  }

  get dynamicSectionsToInclude(): SectionType[] {
    return DocMergeWorkflowConfigService.docMergeSectionTypes;
  }

  get autoFillSections(): SectionType[] {
    return [SectionType.OutputFileName, SectionType.OutputFileType];
  }

  private hasDynamicSections(form: any): FormGroup[] {
    const sections = form?.root?.get('configuration')?.get('sections');
    return sections?.controls?.some((section: FormGroup) =>
      this.dynamicSectionsToInclude.includes(section.get('type')?.value),
    ) as FormGroup[];
  }

  get signatureCombinedOutputDefault(): boolean {
    return true;
  }
}
